import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PopupMenuItem, PopupMenuList } from '$common/popup-menu'
import { ClearHistoryIcon } from '$common/icons/clear-history'
import { RemoveChatIcon } from '$common/icons/remove-chat'
import { t } from '$i18n'

interface Props {
  wappId: string
  isOpen: boolean
}

export function WappProfileMenu({ wappId, isOpen }: Props) {
  return (
    <PopupMenuList open={isOpen}>
      <PopupMenuItem
        text={t('menu.common.removeChat')}
        onClick={async () => {
          await closeCurrentModal()
          //  TODO: Show remove WappRoom confirm dialog
        }}
      >
        <RemoveChatIcon />
      </PopupMenuItem>

      <PopupMenuItem
        text={t('menu.common.clearHistory')}
        onClick={async () => {
          await closeCurrentModal()
          //  TODO: Show clear WappRoom history confirm dialog
        }}
      >
        <ClearHistoryIcon />
      </PopupMenuItem>
    </PopupMenuList>
  )
}
